module.exports = __webpack_public_path__ + "img/banner1.904b7c5f.png";